import { withMobileDetection } from '../../components';

import AvatarProfile from "./AvatarProfile";

export default withMobileDetection(AvatarProfile);
